<template>
  <div id="entryManage">
        <el-form ref="searchForm" style="width:100%" :inline="true" :model="searchForm" :label-position="labelPosition">
            <el-form-item style="margin-bottom:15px"class="hewidth">
                <el-select v-model="searchForm.status" placeholder="请选择入库状态" clearable>
                    <el-option v-for="(item,index) in pickingStatusList" 
                        :label="item.paraName" 
                        :value="item.paraCode" 
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-input clearable v-model.trim="searchForm.qrCode" placeholder="请输入二维码编号"></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-input clearable v-model.trim="searchForm.orderSn" placeholder="请输关联订单号" ></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-input clearable v-model.trim="searchForm.phone" placeholder="请输入手机号码"></el-input>
            </el-form-item>
            <el-form-item style="width: 35% margin-bottom: 15px;">
                <el-button type="primary" size="medium" @click="onSubmit('searchForm')">查询</el-button>
                <el-button type="text" @click="clearFrom()" style="width: 60px;color: #169BD5;">重置</el-button>
                 <el-button type="success" size="medium" @click="downLoad.exportExcel('tableId')">导出</el-button>
                    <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;margin-left: 30px;" @click="refresh()"></i>
            </el-form-item>
            <el-form-item class="fr">
                <el-col style="text-align:right">
                   
                </el-col>
            </el-form-item>
        </el-form>
        <el-col>
            <el-card class="box-card fr" style="width: 100%;">
                <el-table
                    id="tableId"
                    :data="returnData"
                    border
                    :header-cell-style="{'text-align':'center'}"
                    style="width: 100%">
                    <el-table-column
                        prop="orderSn"
                        align="center"
                        width="200"                       
                        label="订单编号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="engineerName"
                        width="150"
                        label="门店工程师">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="phone"
                        width="150"
                        label="手机号码">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="200"
                        label="故障">
                        <template slot-scope="scope">
                            <span style="display:block" v-for="(item,index) in scope.row.faultSubclass" :key="index">{{item.faultSubclassName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="qrCode"
                        label="二维码">
                    </el-table-column>
                    <el-table-column
                        prop="modelName"
                        align="center"
                        width="150"
                        label="型号">
                    </el-table-column>
                    <el-table-column
                        prop="colorName"
                        align="center"
                        label="颜色">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="170"
                        label="状态">
                        <template slot-scope="scope">
                            <el-select v-if="scope.row.status == '1'" v-model="scope.row.maintenanceStatus" style="width: 100%;" clearable>
                                <el-option v-for="(item,index) in pickingRepairStatus" 
                                    :label="item.paraName" 
                                    :value="item.paraValue"
                                    :key="index">
                                </el-option>
                            </el-select>
                            <span v-else>{{ scope.row.maintenanceStatus | sysCodeFileter('maintenance_result')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="remark"
                        label="备注">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="refundReason"
                        label="操作" v-if="basicsAuth.ensure">
                        <template slot-scope="scope">
                            <span class="active-status" v-if="scope.row.status == '1'" @click="confirmBtn(scope.row)">确认收到</span>
                            <span v-else>已收到</span>                            
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
            <!--分页-->
            <el-col :span="24" class="toolbar">
                <div class="pagination">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.page"
                        :page-sizes="[10, 20, 50,100,1000]"
                        :page-size="pages.pageSize"
                        layout="total, sizes, prev, pager, next,jumper"
                        :total="pages.total">
                    </el-pagination>
                </div>
            </el-col>
        </el-col>
    </div>
</template>

<script>
    import { shopInventoryList,confirmEnsure,selectParameterInfoBusiness } from "../../../api/api";
     import {getPermission} from '../../../api/authRequest'
    export default {
        name: 'entryManage',
        data () {
            return {
                pickingStatusList:[
                    {
                        paraName:'待确认',
                        paraCode:'1'
                    },
                    {
                        paraName:'已确认',
                        paraCode:'2'
                    }
                ],
                pickingRepairStatus:[
                    {
                        paraName:'维修完成-已修复',
                        paraValue:1
                    },
                    {
                        paraName:'维修完成-未修复',
                        paraValue:2
                    },
                    {
                        paraName:'维修失败',
                        paraValue:3
                    },
                ],
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                labelPosition:'left',
                searchForm:{
                    type:"3",
                    qrCode:'',  //二维码编号
                    status:'',  //入库状态
                    orderSn:''  //关联订单号
                },
                modelForm:{
                    id:'',
                    orderId:'',
                    maintenanceStatus:"1"
                },
                returnData: [],
                  basicsAuth:{
                    ensure:false
                }
            }
        },
        created(){
            this.basicsAuth.ensure = getPermission('/api/shopInventory/ensure');
            this.getShopInventoryList();
            this.getRepairList()
        },
        methods: {
            //获取维修状态数据
            getRepairList(){
                let para = {
                    paraType:'maintenance_result'
                }
                selectParameterInfoBusiness(para).then(res => {          
                    if (res.data.status==100) {            
                        this.pickingRepairStatus = res.data.results.list;
                        this.pickingRepairStatus.forEach((item,index)=>{
                            item.paraValue = Number(item.paraValue)
                        })
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            confirmBtn(row){
                if(!row.maintenanceStatus){
                    this.$message({
                        message: '请选择维修状态',
                        type: "warning"
                    });
                    return;
                }
                this.modelForm.id = row.id;
                this.modelForm.orderId = row.orderId;
                this.modelForm.maintenanceStatus = row.maintenanceStatus;
                let message = '是否确认收到该设备？';
                this.$confirm(message, '提示', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    this.submitConfirmModel()
                }).catch(action => {
                    
                });
            },
            //确认收到
            submitConfirmModel(){
                confirmEnsure(this.modelForm).then(res => {
                    const loading = this.$loading({
                        lock: true,
                        text: '提交中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.5)'
                    });
                    if (res.data.status==100) {
                        this.$message({
                            message: '提交成功',
                            type: "success"
                        });
                        /*刷新*/
                        this.getShopInventoryList();
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                    loading.close();
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //重置
            clearFrom(){
                Object.keys(this.searchForm).forEach(key => this.searchForm[key]= '');
                this.searchForm.type="3"
                this.getShopInventoryList();
            },
            //获取维修入库列表
            getShopInventoryList(){
                this.searchForm.startRow = this.pages.page;
                this.searchForm.pageSize = this.pages.pageSize;
                shopInventoryList(this.searchForm).then(res => {          
                    if (res.data.status==100) {            
                            this.returnData = res.data.results.list
                            this.returnData.forEach((item,index)=>{
                                item.status = item.status.toString();
                            })
                            this.pages.total = res.data.results.total
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.getShopInventoryList()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.getShopInventoryList()
            },
            //刷新
            refresh() {
                this.clearFrom();
            },
            //检索取机记录
            onSubmit(formname) {
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        this.getShopInventoryList()
                    } else {
                        return false;
                    }
                });
            }
        },
        computed: {},
        watch: {}
    }
</script>

<style type="text/css" lang="scss" scoped>
    .hide-upload{
        .el-upload {
            display: none;
        }
    } 
    #entryManage{
        font-size: 14px;
        .headerT{
            margin:0 0 15px 0;
        }
        tr.el-table__row{
            cursor: pointer;
        }
        input.el-input__inner{
            padding-right:25px; 
        }
        .active-status{
            color:#409EFF;
            cursor:pointer
        }
        .avatar {
            width: 178px;
            height: 178px;
            display: inline-block;
        }
        .yuan{
            position:relative;
            &:after{
                position:absolute;
                right:0;
                content:'元';
                font-size:14px;
                color:#666;
                line-height:40px;
                width:30px;
                height:40px;
                top:0;
                display:block
            }
        }
    }
 .hewidth {
        width: 10% !important;
      }
</style>



// WEBPACK FOOTER //
// entryManage.vue?47489c30